var render = function render(){var _vm=this,_c=_vm._self._c;return _c('handle',{attrs:{"type":"hywj"}})
}
var staticRenderFns = []

export { render, staticRenderFns }